// Web-safe mock for tealium-react-native/common
// Provides Tealium common enums and classes for web

// Collectors enum
export const Collectors = {
  AppData: 'app_data',
  DeviceData: 'device_data',
  Lifecycle: 'lifecycle',
  Connectivity: 'connectivity',
};

// ConsentPolicy enum
export const ConsentPolicy = {
  gdpr: 'gdpr',
};

// ConsentStatus enum
export const ConsentStatus = {
  consented: 'consented',
  notConsented: 'not_consented',
};

// Dispatchers enum
export const Dispatchers = {
  Collect: 'collect',
  TagManagement: 'tag_management',
  RemoteCommands: 'remote_commands',
};

// TealiumEnvironment enum
export const TealiumEnvironment = {
  prod: 'prod',
  dev: 'dev',
  qa: 'qa',
};

// TealiumEvent class
export class TealiumEvent {
  constructor(name, payload = {}) {
    this.name = name;
    this.payload = payload;
  }
}
